import React from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import Errors from "../FormElements/Errors";
import LearningPlanBuilderCourse from "./LearningPlanBuilderCourse";
import LearningPlanBuilderExam from "./LearningPlanBuilderExam";
import Switch from "../FormElements/Switch";

export default class LearningPlanBuilderWorkspace extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="BuilderDropzone">
        <Errors errors={this.props.errors} />
        <Droppable droppableId="dropzone">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {this.props.items && this.props.items.length
                ? this.renderItems()
                : this.renderEmptyDropzone()}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    );
  }

  renderEmptyDropzone() {
    return (
      <div>
        <h2>Create your learning plan</h2>
        <div className="DropzoneInner">
          <div className="DropzoneIcon">
            <span className="fa fa-download"></span>
          </div>
          <h3>Drag or select your first element from the left column</h3>
        </div>
      </div>
    );
  }

  renderName(item) {
    if (item.learnable_type === "Course") {
      if (item.learnable_id) {
        const course = this.props.courses.find(
          (course) => course.id == item.learnable_id
        );
        return course.name;
      } else {
        return (
          I18n.t("admin.learning_plan.name") + " " + I18n.t("admin.course")
        );
      }
    } else {
      if (item.learnable_type === "Exam") {
        return item.name;
      }
    }
  }

  renderItems() {
    return (
      <div className="items">
        <div className="item">
          <li style={{ listStyleType: "none" }}>{this.renderTitleElement()}</li>
        </div>
        {this.props.items.map((item, index) => (
          <div className="item" key={item.id}>
            <Draggable key={item.id} draggableId={item.id} index={index}>
              {(provided, _snapshot) => (
                <li
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  ref={provided.innerRef}
                >
                  {this.renderItem(item)}
                </li>
              )}
            </Draggable>
          </div>
        ))}
      </div>
    );
  }

  renderItem(item) {
    // const isItemInitialized = this.isItemInitialized(item);
    return (
      <div className="BuilderElement">
        <button
          type="button"
          className="btn btn-link btn-sm btn-remove"
          onClick={this.props.onRemoveItem.bind(this, item.id)}
        >
          {I18n.t("admin.remove")}
        </button>
        <div
          className="ElementName"
          style={
            {
              // color: isItemInitialized ? "#000" : "#888",
              // textDecoration: isItemInitialized ? "none" : "line-through",
            }
          }
        >
          <button
            type="button"
            className="btn btn-link btn-sm btn-caret"
            onClick={this.props.onExpandCollapseItem.bind(this, item.id)}
          >
            {" "}
            <span
              className={`fa ${
                item.expanded ? "fa-caret-down" : "fa-caret-right"
              }`}
            ></span>
          </button>
          <span className={"fa " + this.getItemIconName(item)}></span>
          {this.renderName(item)}
        </div>
        {item.expanded ? (
          <div className="BuilderElementBody">{this.renderItemForm(item)}</div>
        ) : null}
        {item.expanded ? (
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={this.props.onExpandCollapseItem.bind(this, item.id)}
          >
            {I18n.t("admin.close")}
          </button>
        ) : null}
      </div>
    );
  }

  renderItemForm(item) {
    if (item.learnable_type === "Exam") {
      return (
        <LearningPlanBuilderExam
          onChangeItem={this.props.onChangeItem}
          courses={this.props.courses}
          item={item}
          {...item}
        />
      );
    } else if (item.learnable_type === "Course") {
      var course = item.learnable;
      if (!course) {
        course = this.props.courses.find(
          (course) => course.id == item.learnable_id
        );
      }
      return (
        <LearningPlanBuilderCourse
          onChangeItem={this.props.onChangeItem}
          courses={this.props.courses}
          course={course}
          item={item}
          {...item}
        />
      );
    }
  }

  renderTitleElement() {
    if (this.props.settingsExpanded) {
      return (
        <div className="BuilderElement TitleElement">
          <div className="row">
            <div className="col-sm-8">
              <div className="form-group">
                <label>{I18n.t("admin.name")}</label>
                <input
                  type="text"
                  name="name"
                  value={this.props.name}
                  className="form-control"
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="col-sm-2">
              <div className="form-group">
                <label>{I18n.t("admin.sequential")}</label>
                <Switch
                  id="sequential"
                  isOn={this.props.sequential}
                  handleToggle={() => {
                    this.props.onChange({
                      target: {
                        name: "sequential",
                        value: !this.props.sequential,
                      },
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-sm-2">
              <div className="form-group">
                <label>{I18n.t("admin.auto_enroll")}</label>
                <Switch
                  id="auto_enroll"
                  isOn={this.props.auto_enroll}
                  handleToggle={() => {
                    this.props.onChange({
                      target: {
                        name: "auto_enroll",
                        value: !this.props.auto_enroll,
                      },
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={this.props.onExpandCollapseSettings}
          >
            {I18n.t("admin.close")}
          </button>
        </div>
      );
    } else {
      return (
        <div className="BuilderElement TitleElement">
          <div className="ElementName">
            <strong>
              {this.props.name && this.props.name !== ""
                ? this.props.name
                : "New Learning Plan"}
            </strong>
          </div>
          <button
            type="button"
            className="btn btn-link btn-sm btn-settings"
            onClick={this.props.onExpandCollapseSettings}
          >
            <span className="fa fa-cog"></span>
          </button>
        </div>
      );
    }
  }

  /**
   * Helpers
   */

  getItemIconName(item) {
    if (item && item.learnable_type === "Course") {
      return "fa-book";
    } else if (item && item.learnable_type === "Exam") {
      return "fa-graduation-cap";
    }
  }

  isItemInitialized(item) {
    if (item.learnable_id) {
      return true;
    }

    return false;
  }
}
